<i18n>
{
  "ru":{
    "invoice_type": "Тип счета",
    "select_account": "Счет для покупателя",
    "email_notifications": "Напоминания по e-mail",
    "add_field": "Добавить поле",
    "shipping": "Стоимость доставки",
    "discount": "Скидка"
  },
  "en":{
    "invoice_type": "Invoice type",
    "select_account": "Select Account",
    "email_notifications": "Email notifications",
    "add_field": "Add field",
    "shipping": "Shipping and Handling",
    "discount": "Discount"
  }
}
</i18n>
<template>
  <el-dialog
    :close-on-click-modal="false"
    append-to-body
    custom-class="webpay invoice"
    :visible.sync="visibleInner"
    top="1vh"
  >
    <section v-loading="loading">
      <el-form
        novalidate
        :show-message="false"
        :model="invoice"
        ref="invoiceForm"
        @submit.native.prevent="save()"
      >
        <el-row :gutter="20">
          <!-- <el-col :sm="5">
            <el-form-item :label="$t('invoice_type') + ':'">
              <el-select
                disabled
                size="medium"
                v-model="invoice.type"
              >
                <el-option
                  label="Обычный счет"
                  value="1"
                ></el-option>
                <el-option
                  label="счет Wizard"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :sm="8">
            <el-form-item
              :rules="requiredValidation"
              :label="$t('select_account') + ':'"
              prop="account_id"
            >
              <div class="el-select el-select--medium">
                <select v-model="invoice.account_id" size="medium">
                  <option
                    v-for="account in accounts"
                    :key="account.value"
                    :label="account.label"
                    :value="account.value"
                  >{{ account.label }}</option>
                </select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :sm="7">
            <el-form-item
              :rules="requiredValidation"
              :label="$t('field_due_date') + ':'"
              prop="due_date"
            >
              <el-date-picker
                v-model="invoice.due_date"
                type="datetime"
                size="medium"
                :picker-options="pickerOptions"
                :format="'yyyy-MM-dd HH:mm'"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="4">
            <el-form-item :rules="requiredValidation" :label="$t('language') + ':'" prop="language">
              <el-select v-model="invoice.language" size="medium">
                <el-option
                  v-for="language in languages"
                  :key="language.value"
                  :label="language.label"
                  :value="language.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="5">
            <el-form-item :rules="requiredValidation" :label="$t('currency') + ':'" prop="currency">
              <el-select v-model="invoice.currency" size="medium">
                <el-option
                  v-for="currency in currencies"
                  :key="currency.value"
                  :label="currency.label"
                  :value="currency.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="5">
            <el-form-item :label="$t('email_notifications') + ':'">
              <el-input
                disabled
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :sm="8">
            <el-form-item
              :rules="requiredValidation"
              :label="$t('invoice_name') + ':'"
              prop="iname"
            >
              <el-input v-model="invoice.iname" size="medium"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="8" v-if="bankList.length">
            <el-form-item :label="$t('bank') + ':'" prop="bank_id">
              <el-select v-model="invoice.bank_id" size="medium" @change="changeBankId" clearable>
                <el-option
                  v-for="bank in bankList"
                  :key="bank.value"
                  :label="bank.label"
                  :value="bank.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :sm="8"
            v-if="bankList.length && invoice.bank_id && terminalList[invoice.bank_id]"
          >
            <el-form-item
              :rules="requiredValidation"
              :label="$t('installment') + ':'"
              prop="terminal_id"
            >
              <el-select v-model="invoice.terminal_id" size="medium">
                <el-option
                  v-for="terminal in terminalList[invoice.bank_id]"
                  :key="terminal.value"
                  :label="terminal.label"
                  :value="terminal.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="invoice.account_id == -1">
          <el-col :sm="8">
            <el-form-item prop="lastname" :rules="requiredValidation" :label="$t('lastname') + ':'">
              <el-input v-model="invoice.lastname" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item
              prop="firstname"
              :rules="requiredValidation"
              :label="$t('firstname') + ':'"
            >
              <el-input v-model="invoice.firstname" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="8">
            <el-form-item :label="$t('address') + ':'">
              <el-input
                disabled
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('phone') + ':'">
              <el-input
                disabled
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :sm="8">
            <el-form-item prop="email" :rules="requiredValidation" label="E-mail:">
              <el-input v-model="invoice.email" size="medium"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="{ span: 6, offset: 18 }">
            <el-button
              @click.prevent="invoice.p.push({})"
              round
              type="primary"
            >{{ $t('add_field') }}</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-table :data="invoice.p">
            <!-- <el-table-column
            prop="template"
            label="Шаблон"
          >
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >
                <el-select
                  placeholder="шаблон"
                  size="mini"
                  v-model="template"
                >
                  <el-option
                    label="шаблон1"
                    value="шаблон1"
                  ></el-option>
                  <el-option
                    label="шаблон2"
                    value="шаблон2"
                  ></el-option>
                </el-select>
              </span>
            </template>
            </el-table-column>-->
            <el-table-column width="100" prop="code" :label="$t('sku')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">
                  <el-form-item :prop="'p.' + scope.$index + '.psku'">
                    <el-input v-model="scope.row.psku" size="mini" :title="scope.row.psku"></el-input>
                  </el-form-item>
                </span>
              </template>
            </el-table-column>
            <el-table-column width="250" prop="name" :label="$t('product_name')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">
                  <el-form-item :prop="'p.' + scope.$index + '.pname'" :rules="requiredValidation">
                    <el-input v-model="scope.row.pname" size="mini" :title="scope.row.pname"></el-input>
                  </el-form-item>
                </span>
              </template>
            </el-table-column>
            <el-table-column width="120" prop="price" :label="$t('price')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">
                  <el-form-item :prop="'p.' + scope.$index + '.pprice'" :rules="priceValidation">
                    <el-input type="number" v-model="scope.row.pprice" size="mini"></el-input>
                  </el-form-item>
                </span>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="quantity" :label="$t('quantity')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">
                  <el-form-item :prop="'p.' + scope.$index + '.pqty'" :rules="qntValidation">
                    <el-input type="number" v-model="scope.row.pqty" size="mini"></el-input>
                  </el-form-item>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="total" :label="$t('total_price_row')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">
                  <span v-if="scope.row.pqty && scope.row.pprice">
                    {{
                    (scope.row.pqty * scope.row.pprice).toFixed(2)
                    }}
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="active" label width="45">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">
                  <el-button
                    circle
                    plain
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    @click.prevent="invoice.p.splice(scope.$index, 1)"
                  ></el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row :gutter="20" style="margin-top: 35px">
          <el-col :sm="12">
            <el-form-item :label="$t('shipping') + ':'" prop="sh">
              <el-input size="medium" v-model="invoice.sh"></el-input>
            </el-form-item>
            <el-form-item :label="$t('discount') + ':'" prop="discount">
              <el-input size="medium" v-model="invoice.discount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item prop="notes" :label="$t('notes') + ':'">
              <el-input v-model="invoice.notes" type="textarea" size="medium"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="el-form-item">
            <label class="el-form-item__label">{{ $t('total_price') }}: {{ totalPrice }}</label>
          </div>
        </el-row>

        <el-row class="aligner">
          <el-button round type="primary" native-type="submit">
            {{
            $t('save')
            }}
          </el-button>
        </el-row>
      </el-form>
    </section>
    <span slot="title">
      <h4>{{ $t('new_invoice') }}</h4>
    </span>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'
export default {
  name: 'invoice-modal',
  props: ['visible', 'callback', 'invoiceData', 'itemData'],
  data: function () {
    return {
      invoice: {
        account_id: '',
        firstname: '',
        lastname: '',
        email: '',
        iname: '',
        currency: '',
        language: '',
        bank_id: '',
        terminal_id: '',
        due_date: '',
        time: '00:00',
        grace_period: 3,
        notice_max: '0',
        p: [{}],
        action_type: '0',
        action_value: '0',
        sh: '',
        discount: '',
        notes: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: this.$t('today'),
          onClick(picker) {
            let date = new Date()
            date.setHours(23, 59, 0, 0)
            picker.$emit('pick', date)
          }
        }
        ]
      },
      requiredValidation: { required: true, trigger: 'blur' },
      qntValidation: { trigger: 'blur', validator: (r, v, c) => { c(/^\d+$/.test(v) && parseInt(v) >= 0 ? undefined : new Error()) } },
      priceValidation: { trigger: 'blur', validator: (r, v, c) => { c(parseFloat(v) >= 0 ? undefined : new Error()) } },
      loading: true,
      languages: [],
      currencies: [],
      accounts: [],
      bankList: [],
      terminalList: {}
    }
  },
  created() {
    this.loading = true
    apiRes.get(apiRes.addInvoiceUrl).then((data) => {
      this.loading = false
      let vars = data.page_vars
      if (vars) {
        if (this.invoiceData) {
          this.invoice.edit = true
          this.invoice.invoice_id = this.invoiceData.id
          this.invoice.account_id = this.invoiceData.account_id
          this.invoice.due_date = new Date(parseInt(this.invoiceData.due_date) * 1000)
          this.invoice.language = this.invoiceData.language_id
          this.invoice.bank_id = this.invoiceData.bank_id
          this.invoice.terminal_id = this.invoiceData.terminal_id
          this.invoice.currency = this.invoiceData.currency_id
          this.invoice.iname = this.invoiceData.po_name
          this.invoice.firstname = this.invoiceData.account_first_name
          this.invoice.lastname = this.invoiceData.account_last_name
          this.invoice.email = this.invoiceData.account_email
          this.invoice.notes = this.invoiceData.notes
          this.invoice.grace_period = this.invoiceData.grace_period
          if (this.itemData && this.itemData.length) {
            this.invoice.p = this.itemData
              .map(i => {
                return { psku: i.sku, pname: i.product_name, pqty: i.quantity, pprice: i.price_base.replace(/[^0-9.]+/g, '') }
              })
              .filter(i => {
                if (i.psku === 'discount') {
                  this.invoice.discount = i.pprice
                  return false
                } else if (i.psku === 'shipping') {
                  this.invoice.sh = i.pprice
                  return false
                }

                return true
              })
          }
        } else {
          Object.assign(this.invoice, vars.v)
          this.invoice.currency = vars.cur
          this.invoice.language = vars.language
          this.invoice.account_id = vars.account_arr.selected_id
          if (vars.invoice_limitation) {
            this.invoice.due_date = new Date(new Date().getTime() + parseInt(vars.invoice_limitation) * 60000)
          }
        }

        if (vars.currency_menu_arr && vars.currency_menu_arr.currency) {
          this.currencies = Object.keys(vars.currency_menu_arr.currency).filter(k => k !== 'selected_id').map(key => {
            return {
              label: key,
              value: vars.currency_menu_arr.currency[key]
            }
          })
        }

        if (vars.language_arr && vars.language_arr.lang) {
          this.languages = Object.keys(vars.language_arr.lang).map(key => {
            return {
              label: key,
              value: vars.language_arr.lang[key]
            }
          })
        }

        if (vars.account_arr.accounts) {
          this.accounts = vars.account_arr.accounts.map(arr => {
            return {
              value: arr[0],
              label: arr[1]
            }
          })
        }

        if (vars.bank_arr) {
          this.bankList = vars.bank_arr.map(b => ({
            value: b.bank_id,
            label: b.bank_name
          }))
        }

        if (vars.terminal_arr) {
          Object.keys(vars.terminal_arr).forEach(k => {
            const terminals = vars.terminal_arr[k]
            this.terminalList[k] = Object.keys(vars.terminal_arr[k]).map(k2 => ({
              value: k2,
              label: terminals[k2]
            }))
          })
        }
      }
    })
  },
  methods: {
    changeBankId() {
      this.invoice.terminal_id = null
    },
    save() {
      this.$refs['invoiceForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          let toSend = {}
          Object.assign(toSend, this.invoice)
          toSend.time = ('0' + toSend.due_date.getHours()).slice(-2) + ':' + ('0' + toSend.due_date.getMinutes()).slice(-2)
          if (!toSend.p.length) toSend.p = undefined
          toSend.notice_send = 'on'
          apiRes.post(apiRes.addInvoiceUrl, toSend).then((res) => {
            this.loading = false
            if (res && res.page_vars && res.page_vars.order_data) {
              if (this.callback) {
                this.callback(res, this.invoice.invoice_id)
              }

              this.visibleInner = false
            }
          })
        }
      })
    }
  },
  computed: {
    totalPrice() {
      let getDefault = (number) => number && parseFloat(number) ? parseFloat(number) : 0
      return (this.invoice
        ? (this.invoice.p ? this.invoice.p : [])
          .map(i => getDefault(i.pqty) * getDefault(i.pprice))
          .reduce((a, b) => { return a + b }, 0) +
        getDefault(this.invoice.sh) - getDefault(this.invoice.discount)
        : 0).toFixed(2)
    },
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>

<style>
.el-dialog.webpay.invoice td,
.el-dialog.webpay.invoice th {
  padding: 0;
  border: none;
  text-align: left;
  font-size: 14px;
}

.el-dialog.webpay.invoice td .cell,
.el-dialog.webpay.invoice th .cell {
  padding: 5px;
}

.el-dialog.webpay.invoice th {
  background: #fff;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
}

.el-dialog.webpay.invoice td .el-form-item {
  margin: 0;
  padding: 0;
}

.el-dialog.webpay.invoice tr:hover {
  background: #efefef;
}
</style>
